module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: {
      'modal--instagram': _vm.isExternalImage(_vm.modalImage)
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideModal($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal__inner"
  }, [(!_vm.item.hideNavigation) ? _c('i', {
    staticClass: "modal__icon modal__icon--previous",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPrevious()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.item.hideNavigation) ? _c('i', {
    staticClass: "modal__icon modal__icon--next",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showNext()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "modal__icon modal__icon--close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__content"
  }, [_c('div', {
    staticClass: "modal__image"
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.imagePath(_vm.modalImage)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal__text"
  }, [_c('header', [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isExternalImage(_vm.modalImage)),
      expression: "!isExternalImage(modalImage)"
    }]
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imagePath(_vm.item.profile)
    }
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.description)
    }
  })]), _vm._v(" "), _c('article', [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isExternalImage(_vm.modalImage)),
      expression: "!isExternalImage(modalImage)"
    }]
  }, [_vm._v("Story")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.story)
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExternalImage(_vm.modalImage)),
      expression: "isExternalImage(modalImage)"
    }],
    attrs: {
      "href": _vm.item.link
    }
  }, [_vm._v("Auf Instagram anzeigen »")])])])]), _vm._v(" "), (_vm.item.items) ? _c('ul', {
    staticClass: "modal__gallery"
  }, _vm._l((_vm.item.items), function(image, index) {
    return _c('li', {
      class: {
        'active': _vm.activeImage === index
      },
      on: {
        "click": function($event) {
          _vm.setActiveImage(image, index)
        }
      }
    }, [_c('figure', [_c('img', {
      attrs: {
        "src": _vm.imagePath(image.image)
      }
    })])])
  })) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-160f9195","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 311
// module chunks = 0